import { createBrowserHistory, createHashHistory } from "history";

const history =
  typeof cordova !== "undefined" ? createHashHistory() : createBrowserHistory();

export default history;



// WEBPACK FOOTER //
// ./src/history.js